"use strict";

import $ from 'jquery';
import Widgets from 'js-widget-hooks';
import URL from 'js-handy-url';
import React from 'react';
import ReactDOM from 'react-dom';
import LocationFinder from '../view/LocationFinder.jsx';
import MapsWidget from '../modules/MapsWidget.jsx';
import app from '../components/app';

/** The location finder module
 *  has a dependency on GLOBAL_CONFIG.site_country
 */


// the places cache
const cache = {}, // holds direct hit responses
    zentrenUrl = new URL('/zentren');

class LocationFinderWidget extends React.Component {

    constructor(props) {
        super(props);

        let url = this.props.urlAction ? new URL(this.props.urlAction.toString()) : zentrenUrl,
            activeCenter = app.getState('active_center')
        ;

        this.state = {
            lastVal : '',
            currentPlaceId : null,
            autoComplete : '',
            autoCompleteCity: '',
            focus_search: false,
            loading: false,
            items: [],
            bestItems: [],
            directHitItems: [], // filled with the results from the direct hit ajax result
            initial: props.config.initial !== undefined ? props.config.initial : true,
            initialText: props.initialText,
            locationDefined: props.config ? props.config.locationDefined : false,
            selectedIndex: 0,
            urlAction: activeCenter ? this.getCenterDetailUrl(activeCenter) : url
        };

        this.lastVal = '';

            // the below variable is filles by the function - it should not set directly
        this.currentProcessedResult = {

            directHitItems: [],
            bestItems: [],
            items: [],

            allItems: []
        };

        this.queryStringLength = 3;
    }

    componentDidMount () {
        let that = this;
        app.subscribe('active_center', function(activeCenter){
            if (activeCenter) {
                that.setState({
                    initial: true,
                    initialText: 'Zentrum: ' + activeCenter.displayName,
                    locationDefined: true,
                    urlAction: that.getCenterDetailUrl(activeCenter)
                });
            }
        });
    }

    // this is it's own event, because otherwise the arrow is jumping around
    handleArrowKeyInteraction (e) {
        var code = (e.keyCode || e.which),
            newIndex = this.state.selectedIndex
            ;
        if (code == 38 || code == 40) {
            e.preventDefault();

            if (this.currentProcessedResult.allItems) {

                newIndex = code == 38 ? newIndex - 1 : newIndex + 1;

                if (newIndex > this.currentProcessedResult.allItems.length - 1) {
                    newIndex = 0; // jump up
                } else if (newIndex < 0) {
                    newIndex = this.currentProcessedResult.allItems.length - 1
                };

                this.setState({
                    selectedIndex : newIndex,
                    urlAction : this.getCenterDetailUrl(this.currentProcessedResult.allItems[newIndex]) // in case the user presses enter
                });
            }
        }
    }

    getCenterDetailUrl (center) {
        if (center.countryCode === this.props.country) {
            if (center.homepage) {
                let centerUrl = new URL(center.homepage);
                if (centerUrl.host === zentrenUrl.host) {
                    return centerUrl.makeRelative();
                }
            }
            return new URL('/' + center.slug);
        }

        return zentrenUrl.clone().setHash('center:' + center.slug);
    }

    handleInputInteraction (e){
        let code = (e.keyCode || e.which),
            val = e.target.value.trim()
            ;

        // do nothing if it's an arrow key
        // because we are linking to the keydown event, the courser does not jump around
        // 38 -> up
        // 40 -> down
        if(code == 37 || code == 38 || code == 39 || code == 40) {
            return;
        }

        // go for the currently selected href
        if(code == 13) {
            this.handleCenterClick(this.currentProcessedResult.allItems ? this.currentProcessedResult.allItems[this.state.selectedIndex] : null, e);
        }

        if (this.lastVal !== val) {
            this.lastVal = val; // we do not use setState here, because no reRender should be caused by this

            if (val) {
                this.getDirectHits(val); // hits from our center database
            } else {
                this.setState({
                    currentPlaceId : null,
                    autoComplete : '',
                    loading: false
                });
            }
        }

    }

    getDirectHits (value) {

        let LOADING_STATE = 0;
        let that = this;


        let setNoResults = function(){
            let allItems = [{
                slug: 'all_centers',
                homepage: zentrenUrl.toString()
            }];

            that.setState({
                currentPlaceId : null,
                loading: false,
                autoComplete : '',
                items : allItems,
                bestItems : null,
                directHitItems: null,
                urlAction : zentrenUrl
            });

            if (that.props.map) {
                that.props.map.reset();
            }

        };

        /**
         *
         * @param {string} cacheId
         */
        let setResultFromCache = function(cacheId) {
            const value = that.lastVal;
            let data = cache[cacheId];

            // when this request came back, are we still in the same context?
            let newLoadingState = getNormalizedValue(that.lastVal).indexOf(cacheId) === 0 ? false : that.state.loading;

            // is is still loading, do we have a context for the current one?
            if (newLoadingState && cache[value]) {
                data = cache[value];
                newLoadingState = false;
            }


            // the place is still valid?
            if (data.place && data.place.properties.name.toLocaleLowerCase().indexOf( getNormalizedValue(that.lastVal) ) > -1) {
                that.setState({
                    directHitItems: getFilteredCenters(data.direct, value),
                    autoComplete: getAutoComplete(value, data.place),
                    autoCompleteCity: data.place.properties.name,
                    items: data.radius,
                    bestItems: data.bestItems,
                    currentPlaceId: normalizedValue,
                    // urlAction: data.radius.length ? that.getCenterDetailUrl(data.radius[0]) : zentrenUrl.toString(), // is this really needed here
                    selectedIndex: 0,
                    loading: newLoadingState
                });

                if (that.props.map) {
                    that.props.map.focus([data.place.geometry.coordinates[1], data.place.geometry.coordinates[0]]);
                }

            } else {

                const directHits = getFilteredCenters(data.direct, value);

                if (!directHits.length && cacheId.length < value.length) {
                    // there is still something in progress - waiting for it, cause we have nothing jet
                    newLoadingState = true;
                }

                that.setState({
                    directHitItems: directHits,
                    autoComplete: '',
                    autoCompleteCity: null,
                    items: [],
                    bestItems: getFilteredCenters(data.bestItems, value),
                    currentPlaceId: null,
                    selectedIndex: 0,
                    loading: newLoadingState
                });
            }
        };

        /**
         * @param {Array} centers
         * @param {String} namePart
         * @returns {Array}
         */
        let getFilteredCenters = function (centers, namePart) {
            return centers.filter(function(center){
                let searchVal = getNormalizedValue(namePart);
                return center.displayName.toLocaleLowerCase().indexOf(searchVal) > -1 ||
                    center.name.toLocaleLowerCase().indexOf(searchVal) > -1
            });
        };

        /**
         * @param val
         * @returns {string}
         */
        let getNormalizedValue = function (val) {
            return val.toLocaleLowerCase();
        };

        /**
         * Returns the actual auto complete value, that makes sense to the user
         * (at least des not look ugly)
         *
         * @param {string} val
         * @param place
         * @returns {string}
         */
        let getAutoComplete = function (val, place) {

            if (!place) {
                return val;
            }

            let normalizedValue = getNormalizedValue(val);
            let normalizedPlaceName = getNormalizedValue(place.properties.name);
            let index = normalizedPlaceName.indexOf(normalizedValue);

            // in case we have a letter mismatch
            if (index < 0) {
                index = 0;
            }


            // first we need to cut the actual name
            return val + place.properties.name.substr(index + val.length);
        };

        // we normalize the value
        let normalizedValue = getNormalizedValue(value);

        // avoid searching for a to broad result set
        if (normalizedValue.length >= this.queryStringLength) {

            if (cache[normalizedValue] === LOADING_STATE) {
                // do nothing
            } else if (cache[normalizedValue] !== undefined) {
                setResultFromCache(normalizedValue);
            } else {
                cache[normalizedValue] = LOADING_STATE; // mark as loading
                let url = '/' + ['zentren', 'query', encodeURI(normalizedValue) + '.json'].join('/');

                this.setState({
                    loading: true
                });

                $.ajax({
                    dataType: "json",
                    url: url,
                    success: function (data) {

                        let bestItems = [],
                            allCenters = {
                                slug: 'all_centers',
                                geo: {
                                    lat: data.place ? data.place.geometry.coordinates[1] : null,
                                    lon: data.place ? data.place.geometry.coordinates[0] : null
                                },
                                homepage: zentrenUrl.toString()
                            }
                        ;

                        data.direct = this.enrichCenterCollection(data.direct);
                        data.radius = this.enrichCenterCollection(data.radius);

                        data.radius = data.radius.filter(function(center){

                            // is this center already in the direct hits?
                            for (let i in data.direct) {
                                if (data.direct[i].id === center.id) {
                                    return false;
                                }
                            }

                            // in case a place is closer then 5 km, we consider it a full hit ;)

                            let centerStartsWithCurrentQuery = center.displayName.toLocaleLowerCase().indexOf(normalizedValue) === 0;

                            if ( center.distance < 5 || centerStartsWithCurrentQuery ) {

                                if (centerStartsWithCurrentQuery) {
                                    data.direct.push(center);
                                } else {
                                    bestItems.push(center);
                                }

                                return false;
                            }

                            // ok, it belongs nowhere else, so it is really a radius event ;)
                            return true;
                        });

                        data.direct.sort(function (center1, center2) {
                            const isHit1 = center1.displayName.toLocaleLowerCase().indexOf(normalizedValue) === 0
                            const isHit2 = center2.displayName.toLocaleLowerCase().indexOf(normalizedValue) === 0

                            if ((isHit1 && isHit2) || (!isHit1 && !isHit2)) {
                                return center1.displayName.localeCompare(center2.displayName);
                            } else if (isHit1) {
                                return -1;
                            }

                            return 1;
                        });

                        data.radius.push(allCenters);
                        data.bestItems = bestItems;

                        // set the cache
                        cache[normalizedValue] = data;

                        setResultFromCache(normalizedValue);

                    }.bind(this),
                    error: function () {
                        cache[normalizedValue] = undefined;
                        setNoResults();
                    }.bind(this)
                });
            }
        } else {
            setNoResults();
        }
    }

    /**
     *
     * @param {Array} centerCollection
     * @returns {Array}
     */
    enrichCenterCollection (centerCollection) {
        centerCollection.forEach(function(center){
            center.url = this.getCenterDetailUrl(center)
        }.bind(this));
        return centerCollection;
    }

    /**
     * Defines what happens, if a the user clicks on a center link of the dropdown or
     * presses the enter key
     *
     * @param center Center
     * @param e Event
     */
    handleCenterClick (center, e) {
        if(e) e.preventDefault();

        if (center) {
            // active_center turned out to be confusing at this point
            app.setState({'current_center': center.slug});
            window.location.href = this.getCenterDetailUrl(center).toString();
        }
    }

    handleInitialClick (e) {
        if( this.props.config && ! this.props.config.locationDefined ){
            e.preventDefault();
            this.handleClearLocation(e);
        }
    }

    handleClearLocation (e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            initial: false,
            focus_search: true
        });

        $(this.refs.view.refs.searchInput).focus();

        app.setState({'current_center': null, 'active_center': null });

        // this.refs.view.refs.searchInput.focus(); // react way of focusing?
        // $( ReactDOM.findDOMNode(this)).find('.search-input').focus();
    }

    setUrlAction (action){
        this.urlAction = action;
    }

    /**
     * This function provides the actual truth for the displayed items just before rendering
     * it removes duplicates and calculates the total item amount
     */
    sortLocationResult () {
        this.currentProcessedResult.directHitItems = this.state.directHitItems ? this.state.directHitItems : [];

        this.currentProcessedResult.bestItems = this.state.bestItems ? this.state.bestItems : [];
        this.currentProcessedResult.items = this.state.items ? this.state.items : [];


        this.currentProcessedResult.allItems = this.currentProcessedResult.directHitItems
            .concat(this.currentProcessedResult.bestItems)
            .concat(this.currentProcessedResult.items);
    }

    render () {
        this.sortLocationResult();

        return <LocationFinder

                ref="view"

                logicClass={this}

                placeholder={this.props.config.placeholder ? this.props.config.placeholder : "Deine Stadt oder PLZ"}

                country={this.props.country}
                initialText={this.state.initialText}
                urlAction={this.state.urlAction}
                locationDefined={this.state.locationDefined}
                initial={this.state.initial}

                loading={this.state.loading}
                items={ this.currentProcessedResult.items }
                directHitItems={this.currentProcessedResult.directHitItems}
                bestItems={ this.currentProcessedResult.bestItems }
                selectedIndex={this.state.selectedIndex}
                autoComplete={this.state.autoComplete}
                currentValue={this.lastVal}
                autoCompleteCity={this.state.autoCompleteCity}
                focus_search={this.state.focus_search}

                noDropdown={!!this.props.map || !this.lastVal}

                handleArrowKeyInteraction={this.handleArrowKeyInteraction.bind(this)}
                handleInputInteraction={this.handleInputInteraction.bind(this)}
                handleInitialClick={this.handleInitialClick.bind(this)}
                handleClearLocation={this.handleClearLocation.bind(this)}
                handleCenterClick={this.handleCenterClick.bind(this)}
            />;
    }
}


// google maps widget
Widgets.register('locationFinder', function (el) {

    // this adds the location finder widget to the Widgets variable - Widgets.init does initialize also this
    var elem = $(el),
        currentUrl = new URL(),
        slug = currentUrl.getHash() && currentUrl.getHash().indexOf('center:') == 0 ? currentUrl.getHash().substr(7) : null,
        config = elem.data('config') ? elem.data('config') : {},
        options = {},
        initialText,
        activeCenter = app.getState('active_center'),
        latitude = activeCenter && activeCenter.geo ? parseFloat(activeCenter.geo.lat) : null,
        longitude = activeCenter && activeCenter.geo ? parseFloat(activeCenter.geo.lon) : null,
        urlAction
        ;

    if (slug) {
        app.setState({'current_center': slug});
    }

    // some tweaks, if we have already a active center
    if (activeCenter && activeCenter.id && config.locationDefined === 'auto') {
        initialText = 'Zentrum: ' + activeCenter.displayName;
        urlAction = activeCenter.homepage;
    } else {
        initialText = elem.find('a').text();
        config.locationDefined = false;
        urlAction = elem.find('a').attr('href');
    }

    // two possibilities - one with map, and one without
    if (config.mapId && document.getElementById(config.mapId)) {

        if (latitude !== null && longitude !== null) {
            options.center = [latitude, longitude];
        }

        let map = ReactDOM.render(
            <MapsWidget
                options={ options }
                centers={ elem.data('centers') }
                additional_centers={ elem.data('additional_centers') }
                focus_centers={config.focus_centers}
            />, document.getElementById(config.mapId)
        );

        ReactDOM.render(
            <LocationFinderWidget
                config={ config } // this is already json :)
                root={ elem }
                map={ map }
                initialText={ initialText }
                urlAction={ urlAction }
                country={GLOBAL_CONFIG.site_country}
            />, el
        );

    } else {

        // no initial gmaps dependency
        ReactDOM.render(
            <LocationFinderWidget
                config={ config } // this is already json :)
                root={ elem }
                initialText={ initialText }
                urlAction={ urlAction }
                country={GLOBAL_CONFIG.site_country}
            />, el
        );

    }

});

// we just return the React class - might be changed later on
export default LocationFinderWidget;